import React, { Component } from 'react';
export { r as reducer } from './reducer-d2bd51aa.js';
export { c as createPost, f as fetch, i as getAllPostIds, e as getAllTags, g as getPostById, a as search, d as selectPost, s as setFilter, b as setPostLoading, u as updatePost, h as uploadImage } from './post.actions-dcd472e5.js';
export { B as BlogsPage, C as Card, a as CardAlt, b as CardHorizontal, c as CardSwing, F as FeaturedPost, P as Pagination } from './blogs.component-5b6cf0d5.js';
export { C as CardAltSmall } from './cardAltSmall.component-f7a0ae0b.js';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import parse from 'html-react-parser';
import { Helmet } from 'react-helmet';
export { B as BlogForm, W as Wysiwyg } from './blogForm.component-cddf3030.js';
export { a as AdminPostListPage, A as AdminPosts } from './adminPostList-85649938.js';
export { N as AdminNewPost, a as AdminNewPostPage } from './adminNewPost-8d7a9a5a.js';
export { E as AdminEditPost, a as AdminEditPostPage } from './adminEditPost-5f3f3a98.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/assertThisInitialized';
import 'react-reveal/Fade';
import 'react-router-dom';
import 'dg-utils';
import 'react-redux';
import 'sweetalert2';
import 'redux-form';
import 'dg-forms';
import '@babel/runtime/helpers/readOnlyError';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import 'draft-js';
import 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'draftjs-to-html';
import 'html-to-draftjs';
import 'dg-forms/dist/index.css';
import 'dg-pagination';
import 'dg-pagination/dist/index.css';

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PostPageSeoTags = /*#__PURE__*/function (_Component) {
  _inherits(PostPageSeoTags, _Component);

  var _super = _createSuper$3(PostPageSeoTags);

  function PostPageSeoTags() {
    _classCallCheck(this, PostPageSeoTags);

    return _super.apply(this, arguments);
  }

  _createClass(PostPageSeoTags, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Helmet, null, this.props.post && this.props.post.slug && window.location.pathname === "/blog/post/".concat(this.props.post._id) ? /*#__PURE__*/React.createElement("link", {
        rel: "canonical",
        href: "".concat(window.location.origin, "/blog/post/").concat(this.props.post.slug)
      }) : '', this.props.post && this.props.post.title ? /*#__PURE__*/React.createElement("title", null, this.props.post.title) : '', this.props.post && this.props.post.title ? /*#__PURE__*/React.createElement("meta", {
        name: "title",
        content: this.props.post.title
      }) : '', this.props.post && this.props.post.title ? /*#__PURE__*/React.createElement("meta", {
        property: "og:title",
        content: this.props.post.title
      }) : '', this.props.post && this.props.post.title ? /*#__PURE__*/React.createElement("meta", {
        property: "twitter:title",
        content: this.props.post.title
      }) : '', this.props.post && this.props.post.summary ? /*#__PURE__*/React.createElement("meta", {
        name: "description",
        content: this.props.post.summary
      }) : '', this.props.post && this.props.post.summary ? /*#__PURE__*/React.createElement("meta", {
        property: "og:description",
        content: this.props.post.summary
      }) : '', this.props.post && this.props.post.summary ? /*#__PURE__*/React.createElement("meta", {
        property: "twitter:description",
        content: this.props.post.summary
      }) : '', this.props.post && this.props.post.header_image ? /*#__PURE__*/React.createElement("meta", {
        property: "og:image",
        content: this.props.post.header_image
      }) : '', this.props.post && this.props.post.header_image ? /*#__PURE__*/React.createElement("meta", {
        property: "twitter:image",
        content: this.props.post.header_image
      }) : '', this.props.post ? /*#__PURE__*/React.createElement("meta", {
        property: "og:url",
        content: window.location.href
      }) : '', this.props.post ? /*#__PURE__*/React.createElement("meta", {
        property: "twitter:url",
        content: window.location.href
      }) : '');
    }
  }]);

  return PostPageSeoTags;
}(Component);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BlogPost = /*#__PURE__*/function (_Component) {
  _inherits(BlogPost, _Component);

  var _super = _createSuper$2(BlogPost);

  function BlogPost() {
    _classCallCheck(this, BlogPost);

    return _super.apply(this, arguments);
  }

  _createClass(BlogPost, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var urlParams = window.location.pathname;
      var params = urlParams.split('/');
      console.log("BlogPost - ".concat(params[3]));
      console.log(params);

      if (Object.keys(this.props.post).length === 0 && params.length >= 4) {
        this.props.getPostById(params[3])["catch"](function (data) {
          console.log(data);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        var urlParams = window.location.pathname;
        var params = urlParams.split('/');
        var urlPostId = params[3];
        this.props.getPostById(urlPostId)["catch"](function (data) {
          console.log(data);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        key: this.props.post._id
      }, /*#__PURE__*/React.createElement(PostPageSeoTags, {
        post: this.props.post
      }), this.props.post && this.props.post.title && this.props.post.title !== '' ? /*#__PURE__*/React.createElement("div", {
        className: this.props.containerClass ? this.props.containerClass : "blog-post"
      }, this.props.hideHeader ? /*#__PURE__*/React.createElement("div", {
        className: "blog-post-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "blog-post-content-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "blog-post-content"
      }, parse(this.props.post.wysiwyg || '')))) : /*#__PURE__*/React.createElement("div", {
        className: "blog-post-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.post && this.props.post.header_image && this.props.post.header_image !== '' ? this.props.post.header_image : header,
        alt: "header"
      })), /*#__PURE__*/React.createElement("div", {
        className: "blog-post-content-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tag-date-info"
      }, this.props.post && this.props.post.tag && this.props.post.tag != '' ? /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("span", {
        className: "badge"
      }, this.props.post.tag)) : '', /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("h6", null, this.props.post.createdAt ? new Date(this.props.post.createdAt).toLocaleDateString('en-uk', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }) : ''))), /*#__PURE__*/React.createElement("h2", null, this.props.post.title || ''), /*#__PURE__*/React.createElement("p", null, this.props.post.summary || '')), /*#__PURE__*/React.createElement("div", {
        className: "blog-post-content"
      }, parse(this.props.post.wysiwyg || ''))))) : this.props.noPostsComponent ? this.props.noPostsComponent : '');
    }
  }]);

  return BlogPost;
}(Component);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BlogPostAlt = /*#__PURE__*/function (_Component) {
  _inherits(BlogPostAlt, _Component);

  var _super = _createSuper$1(BlogPostAlt);

  function BlogPostAlt() {
    _classCallCheck(this, BlogPostAlt);

    return _super.apply(this, arguments);
  }

  _createClass(BlogPostAlt, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var urlParams = window.location.pathname;
      var params = urlParams.split("/");
      console.log("BlogPost - ".concat(params[3]));
      console.log(params);

      if (Object.keys(this.props.post).length === 0 && params.length >= 4) {
        this.props.getPostById(params[3])["catch"](function (data) {
          console.log(data);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$location, _prevProps$location;

      if (((_this$props$location = this.props.location) === null || _this$props$location === void 0 ? void 0 : _this$props$location.pathname) !== ((_prevProps$location = prevProps.location) === null || _prevProps$location === void 0 ? void 0 : _prevProps$location.pathname)) {
        var urlParams = window.location.pathname;
        var params = urlParams.split("/");
        var urlPostId = params[3];
        this.props.getPostById(urlPostId)["catch"](function (data) {
          console.log(data);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$post;

      return /*#__PURE__*/React.createElement("div", {
        className: "post",
        key: (_this$props$post = this.props.post) === null || _this$props$post === void 0 ? void 0 : _this$props$post._id
      }, /*#__PURE__*/React.createElement(PostPageSeoTags, {
        post: this.props.post
      }), this.props.post && this.props.post.title && this.props.post.title !== "" ? /*#__PURE__*/React.createElement("div", {
        className: "blog-post"
      }, this.props.hideHeader ? /*#__PURE__*/React.createElement("div", {
        className: "blog-post-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "blog-post-content-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "blog-post-content"
      }, parse(this.props.post.wysiwyg || "")))) : /*#__PURE__*/React.createElement("div", {
        className: "blog-post-header"
      }, /*#__PURE__*/React.createElement("h1", null, this.props.post.title || ""), /*#__PURE__*/React.createElement("div", {
        className: "blog-author"
      }, this.props.author_image && this.props.author_image !== "" ? /*#__PURE__*/React.createElement("img", {
        src: this.props.author_image && this.props.author_image != "" ? this.props.author_image : "",
        alt: "author avatar"
      }) : "", /*#__PURE__*/React.createElement("p", null, this.props.author_name && this.props.author_name != "" ? "by ".concat(this.props.author_name) : "", /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("h6", null, this.props.post.createdAt ? new Date(this.props.post.createdAt).toLocaleDateString("en-uk", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      }) : "")))), /*#__PURE__*/React.createElement("div", {
        className: "img"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.post && this.props.post.header_image && this.props.post.header_image !== "" ? this.props.post.header_image : this.props.defaultHeader,
        alt: "header"
      })), /*#__PURE__*/React.createElement("div", {
        className: "blog-post-content"
      }, parse(this.props.post.wysiwyg || "")))) : this.props.noPostsComponent ? this.props.noPostsComponent : "");
    }
  }]);

  return BlogPostAlt;
}(Component);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BlogPostAlt2 = /*#__PURE__*/function (_Component) {
  _inherits(BlogPostAlt2, _Component);

  var _super = _createSuper(BlogPostAlt2);

  function BlogPostAlt2() {
    _classCallCheck(this, BlogPostAlt2);

    return _super.apply(this, arguments);
  }

  _createClass(BlogPostAlt2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var urlParams = window.location.pathname;
      var params = urlParams.split("/");
      console.log("BlogPost - ".concat(params[3]));
      console.log(params);

      if (Object.keys(this.props.post).length === 0 && params.length >= 4) {
        this.props.getPostById(params[3])["catch"](function (data) {
          console.log(data);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        var urlParams = window.location.pathname;
        var params = urlParams.split("/");
        var urlPostId = params[3];
        this.props.getPostById(urlPostId)["catch"](function (data) {
          console.log(data);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "post",
        key: this.props.post._id
      }, /*#__PURE__*/React.createElement(PostPageSeoTags, {
        post: this.props.post
      }), this.props.post && this.props.post.title && this.props.post.title !== "" ? /*#__PURE__*/React.createElement("div", {
        className: "blog-post-alt2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "blog-post-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "blog-header-image"
      }, this.props.post && this.props.post.header_image && /*#__PURE__*/React.createElement("img", {
        src: this.props.post.header_image,
        alt: this.props.post.title
      })), /*#__PURE__*/React.createElement("div", {
        className: "blog-header-content"
      }, this.props.post && this.props.post.title && /*#__PURE__*/React.createElement("h1", null, this.props.post.title))), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "blog-date"
      }, /*#__PURE__*/React.createElement("p", null, this.props.post && this.props.post.createdAt && new Date(this.props.post.createdAt).toLocaleDateString("en-GB"))), /*#__PURE__*/React.createElement("div", {
        className: "blog-post-content"
      }, parse(this.props.post.wysiwyg || "")))) : this.props.noPostsComponent ? this.props.noPostsComponent : "");
    }
  }]);

  return BlogPostAlt2;
}(Component);

var Upload = function Upload(field) {
  var files = field.input.value;
  return /*#__PURE__*/React.createElement("div", {
    className: field.containerClass ? field.containerClass : 'field-group'
  }, field.label ? /*#__PURE__*/React.createElement("label", {
    className: field.labelClass
  }, field.label) : '', /*#__PURE__*/React.createElement("div", {
    className: "form-input-container"
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    multiple: field.multiple ? field.multiple : false,
    accept: field.accept ? field.accept : '.jpg, .png, .jpeg',
    onChange: function onChange(filesToUpload, e) {
      return field.input.onChange(filesToUpload);
    },
    disabled: field.disabled
  }), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, field.meta.touched && field.meta.error ? field.meta.error : '')), /*#__PURE__*/React.createElement("div", {
    className: "container-row uploaded_images"
  }, files && Array.isArray(files) && /*#__PURE__*/React.createElement("ul", null, files.map(function (file, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i
    }, file.name);
  }))));
};

var ExampleComponent = function ExampleComponent(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "test"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tested"
  }, "Testing "), "Example Component: ", text);
};

export { ExampleComponent, BlogPost as PostPage, BlogPostAlt as PostPageAlt, BlogPostAlt2 as PostPageAlt2, Upload };
